export default {
  "content": "<g clip-path=\"url(#clip0)\"><path d=\"M1 6a1 1 0 000 2V6zm15 2a1 1 0 100-2v2zM2 4h12V2H2v2zm12 0v8h2V4h-2zm0 8H2v2h12v-2zM2 12V4H0v8h2zm0 0H0a2 2 0 002 2v-2zm12 0v2a2 2 0 002-2h-2zm0-8h2a2 2 0 00-2-2v2zM2 2a2 2 0 00-2 2h2V2zM1 8h15V6H1v2z\" fill=\"#ff00cb\"/></g><defs><clipPath id=\"clip0\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};